import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    GET_PROMOCODE_LISTING,
    ADD_PROMOCODE,
    UPDATE_PROMOCODE,
    DELETE_PROMOCODE,
    EXPORT_PROMOCODE,
    GET_PROMOCODE_DETAILS,
} from "./actionTypes.js";

import {
    getPromocodeListingSuccess,
    getPromocodeListingFail,
    createPromocodeSuccess,
    createPromocodeFail,
    updatePromocodeSuccess,
    updatePromocodeFail,
    deletePromocodeSuccess,
    deletePromocodeFail,
    exportPromocodeSuccess,
    exportPromocodeFail,
    getPromocodeDetailsSuccess,
    getPromocodeDetailsFail,
} from "./actions.js";

import {
    promocodeListingApi,
    promocodeDetailsApi,
    addPromocodeApi,
    updatePromocodeApi,
    deletePromocodeApi,
    exportPromocodeApi,
} from "./promoCodeApi.js";

function* fetchPromocodeListing({ payload }) {
    try {
        const response = yield call(promocodeListingApi, payload);
        yield put(getPromocodeListingSuccess(response));
    } catch (error) {
        yield put(getPromocodeListingFail(error));
    }
}

function* fetchPromocodeDetail({ payload }) {
    try {
        const response = yield call(promocodeDetailsApi, payload);
        yield put(getPromocodeDetailsSuccess(response));
    } catch (error) {
        yield put(getPromocodeDetailsFail(error));
    }
}

function* createPromocode({ payload }) {
    try {
        const response = yield call(addPromocodeApi, payload);
        yield put(createPromocodeSuccess(response));
    } catch (error) {
        yield put(createPromocodeFail(error));
    }
}

function* updatePromocode({ payload }) {
    try {
        const response = yield call(updatePromocodeApi, payload);
        yield put(updatePromocodeSuccess(response));
    } catch (error) {
        yield put(updatePromocodeFail(error));
    }
}

function* deletePromocode({ payload }) {
    try {
        const response = yield call(deletePromocodeApi, payload);
        yield put(deletePromocodeSuccess(response));
    } catch (error) {
        yield put(deletePromocodeFail(error));
    }
}

function* exportPromocode({ payload }) {
    try {
        const response = yield call(exportPromocodeApi, payload);
        yield put(exportPromocodeSuccess(response));
    } catch (error) {
        yield put(exportPromocodeFail(error));
    }
}

function* PromocodeSaga() {
    yield takeEvery(GET_PROMOCODE_LISTING, fetchPromocodeListing);
    yield takeEvery(GET_PROMOCODE_DETAILS, fetchPromocodeDetail);
    yield takeEvery(ADD_PROMOCODE, createPromocode);
    yield takeEvery(UPDATE_PROMOCODE, updatePromocode);
    yield takeEvery(DELETE_PROMOCODE, deletePromocode);
    yield takeEvery(EXPORT_PROMOCODE, exportPromocode);

}

export default PromocodeSaga
